import { render, staticRenderFns } from "./AppFormGroup.vue?vue&type=template&id=96aa31a0"
import script from "./AppFormGroup.vue?vue&type=script&lang=js"
export * from "./AppFormGroup.vue?vue&type=script&lang=js"
import style0 from "./AppFormGroup.vue?vue&type=style&index=0&id=96aa31a0&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports